module.exports = __webpack_public_path__ + "img/background.900743a9.png";